




























// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import TheFormRestaurants2 from '@/components/restaurants/TheFormRestaurants2.vue';
import TheFormRestaurants1 from '@/components/restaurants/TheFormRestaurants1.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
// Importing functions
import {validateRestaurant} from '@/ts/restaurants/validate-restaurant';
import {correctDataCreate, postRestaurant} from '@/ts/restaurants/post-restaurant';
import {getFormData} from '@/ts/helpers';

export default {
    name: 'PageUsersUpdate',
    components: {
        LayoutApp,
        BaseCard,
        BaseAlertList,
        TheFormRestaurants1,
        TheFormRestaurants2,
    },
    props: {},
    data() {
        return {
            data: Object(),
            errors: Array(),
            items: Array(),
            first_page: Boolean(true),
        };
    },
    methods: {
        next() {
            this.first_page = false;
        },
        back() {
            this.first_page = true;
        },
        onSubmit() {
            this.errors = [];

            validateRestaurant(this.errors, this.data);

            if (this.errors.length === 0) {
                correctDataCreate(this.data);

                postRestaurant(getFormData(this.data) as any).then(() => {
                    this.$router.push({ name: 'restaurants' });
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Създаване',
        }];
        // Initializing the user data object
        this.data = {
            name: '', email: '', description: '', town_ekatte: '',
            phone: '', address: '', notes: '', ceo: '', tags: [],
            min_order: '0', expensiveness: '1', legal_name: '',
            image: {}, cover_image: {}, selected_province: '',
            working_hours: [], delivery_prices: [], selected_municipality: '',
        };
        this.$store.dispatch('setLoadingOff');
    },
};
